import { render, staticRenderFns } from "./VectraitsCitationEdit.vue?vue&type=template&id=a00c7d62&scoped=true&"
import script from "./VectraitsCitationEdit.vue?vue&type=script&lang=js&"
export * from "./VectraitsCitationEdit.vue?vue&type=script&lang=js&"
import style0 from "./VectraitsCitationEdit.vue?vue&type=style&index=0&id=a00c7d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00c7d62",
  null
  
)

export default component.exports